import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import JobList from "./pages/joblist";
import PostJob from "./pages/postjob";
import SignIn from "./pages/signin";
import SignUp from "./pages/signup";
import CompleteProfile from "./pages/completeprofile";
import Profile from "./pages/profile";
import EditProfile from "./pages/editprofile";
import AdminPanel from "./components/AdminPanel";
import Blog from "./pages/blog";
import BlogPost from "./pages/blogpost";

function App() {
  return (
    <Routes>
      <Route path="/" element={<JobList />} />
      <Route path="/home" element={<Home />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/jobs" element={<JobList />} />
      <Route path="/post-job" element={<PostJob />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/complete-profile" element={<CompleteProfile />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/edit-profile" element={<EditProfile />} />
      <Route path="/admin" element={<AdminPanel />} />
    </Routes>
  );
}

export default App;
